module.exports = __webpack_public_path__ + "img/UTREDF.049301dd.png";